import { Injectable, NgModuleRef, Type } from '@angular/core';
import { ModuleRegistryType } from './module-loader.service';

export interface RegistryItem {
  componentType: Type<any> | string;
  componentName: string;
  module?: ModuleRegistryType;
}

@Injectable({
  providedIn: 'root'
})
export class DynamicOutletRegistryService {

  /**
  * A registry array of Component Name to details
  * that must be updated with each new component
  * that you wish to load dynamically.
  */
  private _registry = new Map<string, RegistryItem>();
  private _modules = new Map<string, RegistryItem[]>();

  public register(id: string, values: RegistryItem[], moduleRef?: NgModuleRef<any>): void {
    // ensure module is registered only once.

    if (!this._modules.has(id)) {
      console.log('Registering Module components', id);
      this._modules.set(id, values);
    }

    values.forEach(p => {
      if (moduleRef != null) {
        p.module = p.module || moduleRef;
      }

      this._registry.set(p.componentName, p);
    });

  }

  public get(componentName: string): RegistryItem {
    const registryItem = this._registry.get(componentName);
    return registryItem;
  }
}